import Vue from "vue";
import { MultiSelectPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { MultiSelect, CheckBoxSelection } from "@syncfusion/ej2-dropdowns";
Vue.use(MultiSelectPlugin);
// mode="CheckBox" silently does nothing without this module: the control keeps the property but
// renders plain list items, drops the selection display and throws inside updateMainList. The
// injection is global and idempotent, so registering it here makes every consumer of this
// component work regardless of which route chunk happens to be loaded.
MultiSelect.Inject(CheckBoxSelection);
export default Vue.extend({
    props: {
        id: {
            type: String,
            required: true
        },
        dataSource: {
            type: Array,
            required: false
        },
        enabled: {
            type: Boolean,
            required: false,
            default: true
        },
        fields: {
            type: Object,
            required: false
        },
        placeholder: {
            type: String,
            required: false,
            default: ""
        },
        value: {
            type: [String, Boolean, Number, Array],
            required: false
        },
        cssClass: {
            type: String,
            required: false,
            default: ""
        },
        mode: {
            type: String,
            required: false,
            default: "Default"
        }
    },
    data() {
        return {
            dataMsgContainerId: `${this.id}-error`
        };
    },
    methods: {
        emitValue(value) {
            this.$emit("input", value);
        }
    }
});
